export default __webpack_public_path__ + "static/media/cover.4938df1d.jpg";